export enum ItsOverNineThousandFeatureFlags {
    // 25.10
    NovaCoreHireEditJobRequirementsAndQualificationsIssue = 'nova-core-hire-edit-job-requirements-and-qualifications-issue',

    // 25.15
    ImportPermJobEditFormEnhancement = 'import-perm-job-edit-form-enhancement',

    // 25.16
    NovaCoreHireJobRefresh = 'nova-core-hire-job-refresh',

    // 26.02
    NovaCoreHireJobRefreshTracking = 'nova-core-hire-job-refresh-tracking',

    // 26.03
    NovaCoreHireJobRefreshDateInJobsGrid = 'nova-core-hire-job-refresh-date-in-jobs-grid',

    // 26.04
    EscJobImporterAutomaticRecruiterFollowing = 'esc-job-importer-automatic-recruiter-following'
}
